var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 15V4.87947H0.202508V15H3.63281ZM1.9181 3.49686C3.11431 3.49686 3.85889 2.71972 3.85889 1.74856C3.8366 0.755504 3.11436 -6.10352e-05 1.9408 -6.10352e-05C0.767434 -6.10352e-05 0.00012207 0.755519 0.00012207 1.74856C0.00012207 2.71977 0.74452 3.49686 1.89571 3.49686H1.918H1.9181ZM5.53147 15H8.96177V9.34818C8.96177 9.0457 8.98406 8.74354 9.07465 8.52732C9.32263 7.92298 9.88705 7.29706 10.8346 7.29706C12.0759 7.29706 12.5725 8.22514 12.5725 9.58564V14.9999H16.0026V9.19689C16.0026 6.08827 14.3103 4.64187 12.0533 4.64187C10.2028 4.64187 9.39033 5.6562 8.93895 6.34705H8.96185V4.87926H5.53155C5.57657 5.82891 5.53155 14.9997 5.53155 14.9997L5.53147 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.7c592809ca4fe9a388aaa21e1bae0fa0.svg";
export { ForwardRef as ReactComponent };